import MobileModalFrame from "../../common-components/mobile-modal-frame";
import { useTranslation as useInterfaceTranslation } from "react-i18next";
import React, {
  FormEvent,
  useEffect,
  useState,
} from "react";
import { Modal } from "react-bootstrap";
import CrossIcon from "../../../assets/img/order-details/cross.svg";

import "./index.scss";

interface SupplierData {
  name: string;
  email: string;
}

interface SendToSupplierProps {
  show: boolean;
  loading?: boolean;
  onHide: () => void;
  onSubmit: (data: SupplierData) => void;
}

export const SendToSupplier = ({
  show,
  loading = false,
  onHide,
  onSubmit,
}: SendToSupplierProps) => {
  const { t: uiT } = useInterfaceTranslation("interface");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (!show) {
      setName("");
      setEmail("");
    }
  }, [show]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    onSubmit({
      name: name.trim(),
      email: email.trim(),
    });
  };

  return (
    <Modal
      show={show}
      onHide={loading ? undefined : onHide}
      centered
      dialogClassName="send-to-supplier-modal"
      backdrop={loading ? "static" : true}
      keyboard={!loading}
    >
<MobileModalFrame onClose={loading ? undefined : onHide}>
      <div className="send-to-supplier-head">
        <h4> {uiT("Send to factory")} </h4>

        {!loading && (
          <img
            src={CrossIcon}
            alt="סגירה"
            onClick={onHide}
          />
        )}
      </div>

      <form
        className="send-to-supplier-body"
        onSubmit={handleSubmit}
      >
        <label htmlFor="supplier-name"> {uiT("Factory name")} </label>

        <input
          id="supplier-name"
          type="text"
          required
          value={name}
          placeholder={uiT("Enter factory name")}
          onChange={(event) =>
            setName(event.target.value)
          }
        />

        <label htmlFor="supplier-email"> {uiT("Factory email")} </label>

        <input
          id="supplier-email"
          type="email"
          required
          value={email}
          placeholder="supplier@example.com"
          onChange={(event) =>
            setEmail(event.target.value)
          }
        />

        <button
          type="submit"
          disabled={loading}
        >
          {loading && (
            <>
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
              &nbsp;
            </>
          )}

          {loading ? "שולח..." : "שלח למפעל"}
        </button>
      </form>
    </MobileModalFrame>
</Modal>
  );
};

